<div
  id="administration"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'GENERAL.TITLE.ADMINISTRATION' | translate }}
    </div>

    <div class="center option" fxLayout="row">
      <div class="mr-8">
        <button
          (click)="changeDisplay(DisplayMaxi)"
          mat-icon-button
          class="display-btn">
          <mat-icon>grid_view</mat-icon>
        </button>
        <button
          (click)="changeDisplay(DisplayMini)"
          mat-icon-button
          class="display-btn">
          <mat-icon>view_compact</mat-icon>
        </button>
        <button
          (click)="changeDisplay(DisplayList)"
          mat-icon-button
          class="display-btn">
          <mat-icon>view_list</mat-icon>
        </button>
      </div>

      <!-- SEARCH -->
      <div class="search-wrapper">
        <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>search</mat-icon>
          <input
            #servicefilter
            matInput
            [(ngModel)]="searchText"
            placeholder="{{ 'TABLE.FILTER' | translate }}" />
        </div>
      </div>
      <!-- / SEARCH -->
    </div>
  </div>

  <!-- / HEADER -->

  <div class="content-card" fxFill>
    @if (isLoading) {
      <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
    }

    @if (!isLoading && selectedUser) {
      <div class="content">
        @for (message of maintenanceMessage; track message) {
          <div>
            @if (currentLang === 'fr') {
              <div class="row wrap">
                <div class="message-box {{ message.color }}">
                  <div>
                    {{ 'GENERAL.SERVICEMAINTENACE' | translate }}:
                    {{ findService(message.service_oid).title_fr }}
                  </div>
                  <div class="row wrap">{{ message.titre_fr }}</div>
                  <div>{{ message.texte_fr }}</div>
                </div>
              </div>
            }
            @if (currentLang === 'de') {
              <div class="row wrap">
                <div class="message-box {{ message.color }}">
                  <div>
                    {{ 'GENERAL.SERVICEMAINTENACE' | translate }}:
                    {{ findService(message.service_oid).title_de }}
                  </div>
                  <div class="row wrap">{{ message.titre_de }}</div>
                  <div>{{ message.texte_de }}</div>
                </div>
              </div>
            }
          </div>
        }
        @switch (display) {
          @case (0) {
            <app-services-maxi
              [services]="filterServicesAdminTranslated | filter: searchText"
              (accessButtonClick)="onAccessButtonClick($event)"
              (helpButtonClick)="onHelpButtonClick($event)">
            </app-services-maxi>
          }
          @case (1) {
            <app-services-mini
              [services]="filterServicesAdminTranslated | filter: searchText"
              (accessButtonClick)="onAccessButtonClick($event)"
              (helpButtonClick)="onHelpButtonClick($event)">
            </app-services-mini>
          }
          @case (2) {
            <app-services-list
              [services]="filterServicesAdminTranslated"
              [filter]="searchText"
              (accessButtonClick)="onAccessButtonClick($event)"
              (helpButtonClick)="onHelpButtonClick($event)">
            </app-services-list>
          }
        }
        @if (
          (!isLoading && filterServicesAdminTranslated.length === 0) ||
          !selectedUser
        ) {
          <div class="content" fxLayout="row wrap" fxLayoutGap="1rem">
            <div
              id="error-noservice"
              fxLayout="column"
              fxLayoutAlign="center center">
              <div
                class="content"
                fxLayout="column"
                fxLayoutAlign="center center">
                <div class="error-code">
                  {{ 'ERROR.NOSERVICE' | translate }}
                </div>
                <div class="message">
                  {{ 'ERROR.NOSERVICEDESC' | translate }}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
